import React, { useRef } from "react";
import AsyncSelect from "react-select/async";
import _ from "lodash";
import { useEffect } from "react";
import { useState } from "react";
import PrimaryButton from "../infrastructure/Buttons/PrimaryButton";

const FormikAsyncSelect = ({
  formik,
  label = "",
  required = false,
  name,
  onChange,
  getOptions,
  ...props
}) => {
  const computeValue = (options, val) => {
    return options.find((option) => option.value === val);
  };
  const [options, setOptions] = useState([]);
  const handleChange = onChange
    ? onChange
    : (selectedOption) => {
        formik.setFieldValue(name, selectedOption.value);
      };
  const loadOptions = async (value) => {
    const options = await getOptions(value);
    setOptions(options);
    return options;
  };
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        console.log(e);
      }}
    >
      <label className="block text-sm font-medium mb-1" htmlFor={name}>
        {label} {required && <span className="text-rose-500">*</span>}
        {props.secondField}
      </label>
      <AsyncSelect
        name={name}
        value={computeValue(options, _.at(formik.values, name)[0])}
        onBlur={formik.handleBlur}
        onChange={handleChange}
        loadOptions={loadOptions}
        {...props}
      />
      {formik?.errors?.[name] && formik?.touched?.[name] ? (
        <p className="text-xs text-red-500">{formik.errors[name]}</p>
      ) : null}
    </div>
  );
};

export default FormikAsyncSelect;
